import listSaga from './listSaga'
import authUrlSaga from './authUrlSaga'
import oneSaga from './oneSaga'
import connectSaga from './connectSaga'
import disconnectSaga from './disconnectSaga'

const crmSagas = [listSaga(), authUrlSaga(), oneSaga(), connectSaga(), disconnectSaga()]

export default crmSagas
